import React, { useState } from "react";
import {
  Dialog,
  Flex,
  FormField,
  Input,
  Text,
  Dropdown,
} from "@fluentui/react-northstar";
import { Edit } from "react-feather";
import axios from "axios";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const UpdateSkillBridgeModel = (props) => {
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const statusOptions = [
    { key: true, header: "Active" },
    { key: false, header: "Inactive" },
  ];

  const roleOptions = [
    { key: "Ministry", header: "Ministry" },
    { key: "Partner", header: "Partner" },
  ];

  const handleInputChange = (field, value) => {
    props.setItemDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    const { userID, email, firstName, lastName, role, is_active } =
      props.itemDetails || {};

    if (!userID || !email || !firstName?.trim() || !role) {
      toast.error("Please fill in all required fields");
      return;
    }

    setIsLoading(true);
    try {
      const payload = {
        firstName: firstName,
        role: role,
        is_active: String(Boolean(is_active)),
      };
      if (typeof lastName === "string") payload.lastName = lastName;

      await axios.put(
        `${process.env.REACT_APP_EP_URL}/api/skillbridge/sb-users/${userID}${props.user.slug}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + props.user.accessToken,
          },
        }
      );

      toast.success("User updated successfully");
      props.getAllSkillBridgeData();
      props.onClose();
    } catch (error) {
      console.error("Error updating user:", error);
      toast.error("Failed to update user. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    props.setItemDetails({
      userID: "",
      firstName: "",
      lastName: "",
      email: "",
      role: "Ministry",
      is_active: true,
    });
    props.onClose();
  };

  const d = props.itemDetails || {};

  return (
    <Dialog
      open={props.isOpen}
      onCancel={handleClose}
      cancelButton="Cancel"
      confirmButton={{
        content: isLoading ? "Updating..." : "Update",
        loading: isLoading,
        disabled: isLoading,
      }}
      onConfirm={handleSubmit}
      header={`Update ${d.role || "User"}`}
      headerAction={{
        icon: <Edit />,
        title: `Update ${d.role || "User"}`,
      }}
      content={
        <Flex
          column
          gap="gap.medium"
          className="update-skillbridge-model-content"
        >
          <Text content={`Update ${d.role || "User"} details`} />

          <FormField label="Email">
            <Input
              value={d.email || ""}
              disabled
              className="skillbridge-input"
            />
          </FormField>

          <FormField label="First name *">
            <Input
              placeholder="Enter first name"
              value={d.firstName || ""}
              onChange={(_, { value }) => handleInputChange("firstName", value)}
              className="skillbridge-input"
            />
          </FormField>

          <FormField label="Last name">
            <Input
              placeholder="Enter last name"
              value={d.lastName || ""}
              onChange={(_, { value }) => handleInputChange("lastName", value)}
              className="skillbridge-input"
            />
          </FormField>

          <FormField label="Role">
            <Dropdown
              placeholder="Select role"
              items={roleOptions}
              value={roleOptions.find((o) => o.key === d.role)}
              onChange={(_, { value }) => handleInputChange("role", value.key)}
              className="select-provider-dropdown"
            />
          </FormField>

          <FormField label="Status">
            <Dropdown
              placeholder="Select status"
              items={statusOptions}
              value={statusOptions.find((o) => o.key === Boolean(d.is_active))}
              onChange={(_, { value }) =>
                handleInputChange("is_active", value.key)
              }
              className="select-provider-dropdown"
            />
          </FormField>
        </Flex>
      }
    />
  );
};

export default UpdateSkillBridgeModel;
